import React from 'react'
import s from './TrayMenu.scss'
import { nodeExplorer } from '../Flow.data'
import TrayWidget from '../TrayWidget'
import cn from 'classnames'
import Button from 'components/Button'
import sLay from 'styles/modules/layout.scss'
import { reduxForm, Form, Field } from 'redux-form'
import { Input } from 'components/Input/Input'
import { vRequired } from 'components/Input/Input.validations'
import { moment } from 'features/Moment'
import SimpleTable from 'components/Tables/SimpleTable'

export const TrayMenu = props => {
  const { saveFlow, publishFlow, flow, handleSubmit, savePending, publishPending } = props

  return (
    <Form onSubmit={handleSubmit(saveFlow)} className={cn(sLay['layout-column'], sLay.flex)}>
      <div className={cn(s.form)}>
        <div className={sLay['hide-xs']}>
          <Field name="name" component={Input} label="Name" validate={[vRequired]} />
        </div>
        <SimpleTable>
          <div>
            <div>Last saved:</div>
            <div>{moment(flow.lastEdited).fromNow()}</div>
          </div>
          <div>
            <div>Last published:</div>
            <div> {flow.published ? moment(flow.lastPublished).fromNow() : 'Never'}</div>
          </div>
        </SimpleTable>
      </div>
      <div
        className={cn(sLay['layout-column'], sLay.flex, sLay['hide-xs'])}
        style={{ overflowY: 'auto' }}
      >
        {nodeExplorer(flow.type).map(group => (
          <div key={group.label}>
            <div className={s.groupTitle}>{group.label}</div>
            {group.nodes.map(nodeType => (
              <TrayWidget key={nodeType} nodeType={nodeType} />
            ))}
          </div>
        ))}
        <div className={sLay.flex} />
      </div>
      <div className={cn(s.footer, sLay['layout-column'])}>
        <Button
          style={{ marginBottom: '15px' }}
          color="tertiary"
          rect
          ghost
          type="submit"
          loading={savePending}
          className={sLay['hide-xs']}
        >
          Save
        </Button>
        <Button
          onClick={handleSubmit(publishFlow)}
          color="tertiary"
          rect
          type="button"
          loading={publishPending}
        >
          Save & Publish
        </Button>
      </div>
    </Form>
  )
}

export default reduxForm({
  destroyOnUnmount: false,
})(TrayMenu)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/TrayMenu/TrayMenu.jsx